import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo, useState } from "react";
export const ConsumablesProductDetailsContext = createContext({} // useConsumablesProductDetailsContext will throw an error if this context is not provided
);
const findCurrentConsumable = (sku, consumablesMatrixData) => {
    const consumablesMatrixItemData = consumablesMatrixData.items.find((item) => item.sku === sku);
    if (!consumablesMatrixItemData) {
        throw new Error(`Couldn't find product with SKU: ${sku}`);
    }
    return consumablesMatrixItemData;
};
export const ConsumablesProductDetailsProvider = ({ children, data }) => {
    const [currentSKU, setCurrentSKU] = useState(data.sku);
    const currentMatrixItem = useMemo(() => {
        return findCurrentConsumable(currentSKU, data.consumablesMatrixData);
    }, [currentSKU, data.consumablesMatrixData]);
    if (!data) {
        throw new Error("ConsumablesProductDetailsProvider: data prop is required");
    }
    const contextValue = useMemo(() => ({
        consumablesProductDetailsComponentData: data,
        currentMatrixItem,
        setCurrentSKU,
    }), [data, currentMatrixItem, setCurrentSKU]);
    return (_jsx(ConsumablesProductDetailsContext.Provider, { value: contextValue, children: children }));
};
//# sourceMappingURL=ConsumablesProductDetailsProvider.js.map